export const formatNumber = (n: number) => {
  return n.toLocaleString("hu-HU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatIntegerNumber = (n: number) => {
  return n.toLocaleString("hu-HU", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
